export default __webpack_public_path__ + "static/Juliano Guerra_MinBio-2b8be9c6c457f8e9e62422334ea87d01.webp";